/**
 * @brief 本地 Node Server 上的多 provider LLM 聊天接口封装
 * @note 与 VoiceChat 不同，这组 API 不走火山 OpenAPI 签名，响应体也不带 ResponseMetadata 包装
 */

import { AIGC_PROXY_HOST } from '@/config';
import type { LlmProvider } from '@/lib/commands';

export interface ChatMessage {
  role: 'system' | 'user' | 'assistant';
  content: string;
}

export interface ChatRequest {
  provider: LlmProvider;
  model: string;
  baseURL?: string;
  apiKey?: string;
  systemPrompt?: string;
  messages: ChatMessage[];
}

export interface ChatResponse {
  text: string;
}

export const chat = async (req: ChatRequest): Promise<ChatResponse> => {
  const res = await fetch(`${AIGC_PROXY_HOST}/llm/chat`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(req),
  });
  if (!res.ok) {
    throw new Error(`[llm/chat] HTTP ${res.status}`);
  }
  const data = await res.json();
  if (typeof data?.text !== 'string') {
    throw new Error(`[llm/chat] 响应格式异常: ${JSON.stringify(data)}`);
  }
  return data as ChatResponse;
};

const Llm = { chat };
export default Llm;
